import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ApiService } from '../../core/api';
import { ResponseDatas } from '../../core/api/types';

import {
  CompanyUserManagementAddUser,
  CompanyUserManagementAddUsersResponse,
  CompanyUserManagementSettings
} from './types';

@Injectable({
  providedIn: 'root'
})
export class CompanyUserManagementService {
  constructor(private readonly apiService: ApiService) {}

  addUsers(
    featureClientID: number,
    payload: CompanyUserManagementAddUser[]
  ): Observable<CompanyUserManagementAddUsersResponse> {
    return this.apiService
      .post<
        ResponseDatas<CompanyUserManagementAddUsersResponse>
      >(`company-user-management/${featureClientID}/users/add`, payload)
      .pipe(map((result) => result?.datas));
  }

  deleteUser(featureClientID: number, customerID: number): Observable<void> {
    return this.apiService.delete(`company-user-management/${featureClientID}/users/remove/${customerID}`);
  }

  updateSettings(payload: CompanyUserManagementSettings): Observable<CompanyUserManagementSettings> {
    return this.apiService
      .put<ResponseDatas<CompanyUserManagementSettings>>('company-user-management', payload)
      .pipe(map((result) => result?.datas));
  }

  updateUsers(
    featureClientID: number,
    payload: CompanyUserManagementAddUser[]
  ): Observable<CompanyUserManagementAddUsersResponse> {
    return this.apiService
      .patch<
        ResponseDatas<CompanyUserManagementAddUsersResponse>
      >(`company-user-management/${featureClientID}/users`, payload)
      .pipe(map((result) => result?.datas));
  }
}
